import React from 'react';
import './current-role-summary.scss';

export interface CurrentRoleSummaryProps {
  currentRole: string;
}

const CurrentRoleSummary = ({ currentRole }: CurrentRoleSummaryProps) => (
  <div className="current-role-summary">
    <span className="current-role-summary-label">Current role</span>
    <span className="current-role-summary-value">{currentRole}</span>
  </div>
);

export default CurrentRoleSummary;
